module.exports = __webpack_public_path__ + "media/XIAOMI.02be0724.mp4";